import { StateCreator } from "zustand";

export interface MessageSlice {
  messageZustand: string | null;
  messageTypeZustand: "success" | "error" | null;

  setMessageZustand: (message: string, messageType: string) => void;
  removeMessageZustand: () => void;
}

export const createMessageSlice: StateCreator<MessageSlice> = (set: any) => ({
  messageZustand: null,
  messageTypeZustand: null,
  setMessageZustand: (message, messageType) => {
    set({ messageZustand: message, messageTypeZustand: messageType });
    setTimeout(() => {
      set({ messageZustand: null, messageTypeZustand: null });
    }, 3000);
  },
  removeMessageZustand: () =>
    set({ messageZustand: null, messageTypeZustand: null }),
});
